module.exports = __webpack_public_path__ + "img/3.6e4d4b9c.svg";